import axios from "axios";
import {db_url, url_warehouse, url_warehouse_depend, url_warehouse_filter,} from "../url";


export default function DB_Warehouse (token) {

    const add_url = '/dictionary/warehouse'

    const formData = new FormData();
    formData.append('token', token);

    const appendToken = (data) => {
        const fd = new FormData();
        for (const pair of data.entries()) {
            fd.append(pair[0], pair[1]);
        }
        fd.append('token', token);
        return fd
    }


    const getActiveWarehouses = (branch_id) => {

        let params = {}
        if (branch_id != null) {
            params = {
                branch_id: branch_id
            }
        }

        // if (branch_id != null) {
        //     return axios.get(db_url + `/dictionary/warehouses/active`, {
        //         params: {
        //             branch_id: branch_id
        //         },
        //         headers: {
        //             Authorization: token
        //         }
        //     })
        // } else {
            return axios.get(db_url + `/dictionary/warehouses/active`, {
                params: params,
                headers: {
                    Authorization: token
                }
            })
        // }


    }


    const getWarehouses = (controller, search) => {
        return axios.get(db_url + '/dictionary/warehouses', {
            signal: controller.signal,
            params: search,
            headers: {
                Authorization: token
            }
        })
    }


    const getWarehouse = (warehouse_id) => {
        return axios.post(url_warehouse+warehouse_id, formData);
    }

    const createWarehouse = (data) => {
        return axios.post(url_warehouse, appendToken(data))
    }

    const updateWarehouse = (data) => {
        return axios.put(url_warehouse, appendToken(data))
    }

    const statusWarehouse = (id) => {
        return axios.put(db_url + `/dictionary/warehouses/${id}`, null, {
            headers: {
                Authorization: token
            }
        })
    }

    const defaultWarehouse = (id) => {
        return axios.patch(db_url + add_url, null, {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }

    const dependWarehouse = (id) => {
        return new Promise(resolve => {
            axios.get(url_warehouse_depend+ id)
                .then(res => {
                    if(res.status === 200){
                        resolve(false)
                    } else {
                        resolve(true)
                    }
                })
        })
    }

    async function getWarehouseFilter(name) {
        const formData = new FormData()
        formData.append('name', name)

        return new Promise(resolve => {
            axios.post(url_warehouse_filter, appendToken(formData))
                .then(res => {
                    const data = res.data.map(w => (
                        {
                            label: w.name,
                            value: w.id
                        }
                    ))
                    resolve(data)
                })
        })
    }

    return {
        getWarehouses,
        getWarehouse,
        getActiveWarehouses,
        createWarehouse,
        updateWarehouse,
        statusWarehouse,
        dependWarehouse,
        getWarehouseFilter,
        defaultWarehouse,
    }

}
